// extracted by mini-css-extract-plugin
export const sectionRoot = "P_bF";
export const contentRoot = "P_bH";